import { IPHONE_SPECS, IPHONE_MODELS } from "@/lib/store";

// Lista de iPhones do estoque e da troca: do iPhone 12 em diante, sem SE, linha 11 e versões mini.
const S64 = ["64GB", "128GB", "256GB"];
const S128 = ["128GB", "256GB", "512GB"];
const PRO12 = ["Grafite", "Prateado", "Dourado", "Azul-pacífico"];
const colorsOf = (m) => IPHONE_SPECS[m].colors;

const EXTRA = {
  "iPhone 12": { storages: S64, colors: ["Preto", "Branco", "Vermelho", "Verde", "Azul", "Roxo"] },
  "iPhone 12 Pro": { storages: S128, colors: PRO12 },
  "iPhone 12 Pro Max": { storages: S128, colors: PRO12 },
  "iPhone 14 Plus": { storages: S128, colors: colorsOf("iPhone 14") },
  "iPhone 15 Plus": { storages: S128, colors: colorsOf("iPhone 15") },
  "iPhone 16e": { storages: S128, colors: ["Preto", "Branco"] },
  "iPhone 16 Plus": { storages: S128, colors: colorsOf("iPhone 16") },
};

export const STOCK_IPHONES = IPHONE_MODELS.filter((m) => !/mini|iPhone 11/i.test(m)).reverse();
export const stockIphoneSpec = (model) => IPHONE_SPECS[model] || EXTRA[model] || null;
export const ANY_STORAGES = ["32GB", "64GB", "128GB", "256GB", "512GB", "1TB", "2TB"];
export const OTHER = "Outro (digitar)";
